module.exports = __webpack_public_path__ + "static/02_mobile@2x-bae28a2269e4aa3b9340b971e3c699f6.png";